<button
  (click)="clickHandler($event)"
  class="ds-button"
  [ngClass]="{
    'ds-button--loading': loadingSg(),
    'ds-button--disabled': disabledSg(),
    'ds-button--primary': styleSg() === styleEnum.Primary,
    'ds-button--secondary': styleSg() === styleEnum.Secondary,
    'ds-button--success': styleSg() === styleEnum.Success,
    'ds-button--info': styleSg() === styleEnum.Info,
    'ds-button--warning': styleSg() === styleEnum.Warning,
    'ds-button--danger': styleSg() === styleEnum.Danger,
    'ds-button--transparent': styleSg() === styleEnum.Transparent,
    'ds-button--white': styleSg() === styleEnum.White,
    'ds-button--gray': styleSg() === styleEnum.Gray,
    'ds-button--is-icon': isIconSg(),
  }"
>
  <ng-content />
</button>
